const pageNameKey = "dragImage";

export const dragImageEn = {
  [pageNameKey]: {
    checkBoxIconAltText: "Checkbox icon",
    dragImageAltText: "Dragged element icon",
  },
};

export const dragImagePtBr = {
  [pageNameKey]: {
    checkBoxIconAltText: "Ícone da caixa de seleção",
    dragImageAltText: "Ícone do elemento arrastado",
  },
};

export const dragImageDe = {
  [pageNameKey]: {
    checkBoxIconAltText: "Checkbox-Icon",
    dragImageAltText: "Ziehen Sie das Element-Icon",
  },
};

export const dragImageZhHans = {
  [pageNameKey]: {
    checkBoxIconAltText: "复选框图标",
    dragImageAltText: "拖动的元素图标",
  },
};

export const dragImageIt = {
  [pageNameKey]: {
    checkBoxIconAltText: "Icona di casella di spunta",
    dragImageAltText: "Icona dell'elemento trascinato",
  },
};

export const dragImageEs = {
  [pageNameKey]: {
    checkBoxIconAltText: "Icono de casilla de verificación",
    dragImageAltText: "Icono del elemento arrastrado",
  },
};

export const dragImageNl = {
  [pageNameKey]: {
    checkBoxIconAltText: "Selectievakje-pictogram",
    dragImageAltText: "Drag & Drop het elementpictogram",
  },
};

export const dragImageTr = {
  [pageNameKey]: {
    checkBoxIconAltText: "Onay kutusu simgesi",
    dragImageAltText: "Sürüklenen öğe simgesi",
  },
};
